<template>
    <div class="guide-box">
        <!-- <div class="title" style="text-align: center;">新资金分账设置指南</div>
        <div class="title">步驟</div>
        <div class="content">
            第1步：创建收款人
            <div>第2步：收款人实名认证、银行卡绑定与提现</div>
            <div>第3步：收款人与设备绑定</div>
            <div>第4步：分账明细查询</div>
        </div>
        <div class="title">一、创建收款人</div>
        <div class="content">
            1、登录合作伙伴后台，进入“财务管理”“收款人管理”，点击“新增收款人”
            <div>第2步：收款人实名认证、银行卡绑定与提现</div>
            <div>第3步：收款人与设备绑定</div>
            <div>第4步：分账明细查询</div>
        </div> -->
        <div class="content">
            <img :src="i" v-for="(i,j) in imgs" :key="j">
        </div>
    </div>
</template>

<script>
import config from '@/config'
export default {
  data () {
    return {
      imgs: [require('../../assets/images/guide/page1.jpg'),
        require('../../assets/images/guide/page2.jpg'),
        require('../../assets/images/guide/page3.jpg'),
        require('../../assets/images/guide/page4.jpg'),
        require('../../assets/images/guide/page5.jpg'),
        require('../../assets/images/guide/page6.jpg'),
        require('../../assets/images/guide/page7.jpg'),
        require('../../assets/images/guide/page8.jpg'),
        require('../../assets/images/guide/page9.jpg')
      ]
    }
  },
  created () {
  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
@import "./guide.less";
</style>
